export const data = {
  "objectives": {
    "wom": {
      "nano": 10,
      "micro": 3,
      "macro": 1,
      "star": 1,
    },
    "insights": {
      "nano": 10,
      "micro": 3,
      "macro": 1,
      "star": 1,
    },
    "posTraffic": {
      "nano": 10,
      "micro": 5,
      "macro": 1,
      "star": 1,
    },
    "premiumTrials": {
      "nano": 10,
      "micro": 3,
      "macro": 1,
      "star": 1,
    },
    "ratings": {
      "nano": 10,
      "micro": 4,
      "macro": 1,
      "star": 1,
    },
    "authContent": {
      "nano": 10,
      "micro": 8,
      "macro": 4,
      "star": 1,
    },
    "engagement": {
      "nano": 1,
      "micro": 10,
      "macro": 8,
      "star": 6,
    },
    "onlineReach": {
      "nano": 5,
      "micro": 5,
      "macro": 7,
      "star": 8,
    },
    "websiteTraffic": {
      "nano": 1,
      "micro": 3,
      "macro": 10,
      "star": 8,
    },
    "profContent": {
      "nano": 1,
      "micro": 5,
      "macro": 10,
      "star": 5,
    },
    "productStaging": {
      "nano": 1,
      "micro": 2,
      "macro": 10,
      "star": 7,
    },
    "storytelling": {
      "nano": 1,
      "micro": 2,
      "macro": 10,
      "star": 5,
    },
    "imageShaping": {
      "nano": 1,
      "micro": 1,
      "macro": 5,
      "star": 10,
    },
    "testimonials": {
      "nano": 5,
      "micro": 3,
      "macro": 5,
      "star": 10,
    },
    "awareness": {
      "nano": 10,
      "micro": 5,
      "macro": 10,
      "star": 5,
    },
    "sampling": {
      "nano": 10,
      "micro": 2,
      "macro": 7,
      "star": 8,
    },
    "education": {
      "nano": 10,
      "micro": 8,
      "macro": 1,
      "star": 1,
    },
  },
  "industries": {
    "beauty": {
      "nano": 10,
      "micro": 10,
      "macro": 10,
      "star": 10,
    },
    "automotive": {
      "nano": 1,
      "micro": 3,
      "macro": 10,
      "star": 7,
    },
    "travel": {
      "nano": 1,
      "micro": 3,
      "macro": 10,
      "star": 5,
    },
    "pharma": {
      "nano": 10,
      "micro": 4,
      "macro": 4,
      "star": 1,
    },
    "tech": {
      "nano": 5,
      "micro": 5,
      "macro": 10,
      "star": 4,
    },
    "eCom": {
      "nano": 10,
      "micro": 10,
      "macro": 10,
      "star": 10,
    },
    "fashion": {
      "nano": 3,
      "micro": 3,
      "macro": 7,
      "star": 10,
    },
    "foodBev": {
      "nano": 10,
      "micro": 10,
      "macro": 10,
      "star": 5,
    },
    "household": {
      "nano": 10,
      "micro": 10,
      "macro": 10,
      "star": 3,
    },
    "finance": {
      "nano": 10,
      "micro": 4,
      "macro": 4,
      "star": 1,
    },
    "games": {
      "nano": 10,
      "micro": 3,
      "macro": 8,
      "star": 1,
    },
    "energy": {
      "nano": 10,
      "micro": 4,
      "macro": 4,
      "star": 1,
    },
    "other": {
      "nano": 5,
      "micro": 5,
      "macro": 5,
      "star": 5,
    },
  },
  "ageRanges": {
    "1to5": {
      "nano": 10,
      "micro": 1,
      "macro": 10,
      "star": 1,
    },
    "6to12": {
      "nano": 10,
      "micro": 1,
      "macro": 10,
      "star": 1,
    },
    "13to18": {
      "nano": 1,
      "micro": 3,
      "macro": 8,
      "star": 10,
    },
    "19to24": {
      "nano": 5,
      "micro": 5,
      "macro": 8,
      "star": 10,
    },
    "25to34": {
      "nano": 5,
      "micro": 6,
      "macro": 10,
      "star": 6,
    },
    "35to44": {
      "nano": 10,
      "micro": 8,
      "macro": 7,
      "star": 4,
    },
    "45to54": {
      "nano": 9,
      "micro": 7,
      "macro": 3,
      "star": 2,
    },
    "55to64": {
      "nano": 10,
      "micro": 6,
      "macro": 2,
      "star": 1,
    },
    "65plus": {
      "nano": 10,
      "micro": 2,
      "macro": 1,
      "star": 1,
    },
  },
}
